import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { AutenticacionService } from '../../services/autenticacion.service';
import { ExpedientesService } from 'src/app/services/expedientes.service';
import { Expedientes_Lista } from 'src/app/models/generic/Expedientes_Lista';
import { Expedientes_Detalle_InformacionGeneral_DTO } from 'src/app/models/generic/Expedientes_Detalle_InformacionGeneral';
import { Expedientes_Detalle_Expediente_DTO } from 'src/app/models/generic/Expedientes_Detalle_Expediente';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { GestionAfiliadoService } from 'src/app/services/gestionafiliado.service';
import { GestionAfiliado } from 'src/app/models/generic/GestionAfiliado';
import { GestionAfiliado_Parametro } from 'src/app/models/generic/GestionAfiliado_Parametro';
import { ListaAliadosCanales } from 'src/app/models/generic/ListaAliadosCanales';

@Component({
  selector: 'expedientes-detalle',
  templateUrl: './expedientes-detalle.component.html',
  styleUrls: ['./expedientes-detalle.component.scss']
})
export class ExpedientesDetalleComponent implements OnInit{
  ESTADOS_NUEVO: string = 'A';
  ESTADOS_PROCESO: string = 'P';
  ESTADOS_SEGUIMIENTO: string = 'S';
  ESTADOS_TERMINADO: string = 'T';
  CONCEPTO_ADJUNTO: string = 'Adjunto';
  TIPODETALLE_MONITOREO: string = 'Monitoreo';
  TIPODETALLE_OCURRIDO: string = 'Ocurrido';
  TIPODETALLE_OBSERVACIONES: string = 'Observaciones';
  TIPODETALLE_ASIGNACION: string = 'Asignación';
  TIPODETALLE_ADJUNTO: string = 'Adjunto';

  mostrarCargando: boolean = false;
  expediente: string = '';
  itemDetalleInformacionGeneral: Expedientes_Detalle_InformacionGeneral_DTO = new Expedientes_Detalle_InformacionGeneral_DTO();
  listaDetalleInformacionGeneral: Expedientes_Detalle_InformacionGeneral_DTO[] = [];
  itemDetalleExpedientes: Expedientes_Detalle_Expediente_DTO = new Expedientes_Detalle_Expediente_DTO();
  listaDetalleExpedientes: Expedientes_Detalle_Expediente_DTO[] = [];
  listaDetalleOcurrido: Expedientes_Detalle_Expediente_DTO[] = [];
  listaDetalleAsignado: Expedientes_Detalle_Expediente_DTO[] = [];
  listaDetalleMonitoreo: Expedientes_Detalle_Expediente_DTO[] = [];
  listaDetalleAdjuntos: Expedientes_Detalle_Expediente_DTO[] = [];
  listaDetalleVistaGeneral: Expedientes_Detalle_Expediente_DTO[] = [];
  listaNumerosAdicion: number[] = [];
  mostrarContenidoPrincipal: boolean = true;
  mostrarContenidoInformacionAfiliado: boolean = true;
  mostrarContenidoDatosAfiliado: boolean = true;
  mostrarContenidoDatosContactante: boolean = false;
  mostrarContenidoInformacionExpediente: boolean = true;
  mostrarContenidoVistaGeneral: boolean = true;
  mostrarContenidoDetalleExpediente: boolean = true;
  tabSeleccionado: number = 0;
  idFinal: number = 0;
  conceptoFinal: string = '';
  fechaFinal: Date;

  @ViewChild('paginatorExpedientes') paginatorExpedientes: MatPaginator;
  dataSourceExpedientes: MatTableDataSource<Expedientes_Detalle_Expediente_DTO>;
  columnasExpedientes: string[] = ['nro', 'asunto', 'concepto', 'fecha', 'accion'];

  @ViewChild('paginatorOcurrido') paginatorOcurrido: MatPaginator;
  dataSourceOcurrido: MatTableDataSource<Expedientes_Detalle_Expediente_DTO>;
  columnasOcurrido: string[] = ['nro', 'asunto', 'concepto', 'fecha'];
  
  @ViewChild('paginatorAsignacion') paginatorAsignacion: MatPaginator;
  dataSourceAsignacion: MatTableDataSource<Expedientes_Detalle_Expediente_DTO>;
  columnasAsignacion: string[] = ['nro', 'asunto', 'concepto', 'fecha'];

  @ViewChild('paginatorMonitoreo') paginatorMonitoreo: MatPaginator;
  dataSourceMonitoreo: MatTableDataSource<Expedientes_Detalle_Expediente_DTO>;
  columnasMonitoreo: string[] = ['nro', 'asunto', 'concepto', 'fecha'];

  @ViewChild('paginatorAdjuntos') paginatorAdjuntos: MatPaginator;
  dataSourceAdjuntos: MatTableDataSource<Expedientes_Detalle_Expediente_DTO>;
  columnasAdjuntos: string[] = ['nro', 'asunto', 'concepto', 'fecha', 'accion'];
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: ExpedientesService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService,
    public gestionAfiliadoService: GestionAfiliadoService) {}

  ngOnInit() {
    this.IniciarFormulario();

    this.listaNumerosAdicion.push(0);
    this.listaNumerosAdicion.push(1);
    this.listaNumerosAdicion.push(2);
    this.listaNumerosAdicion.push(3);
    this.listaNumerosAdicion.push(4);
    this.listaNumerosAdicion.push(5);
    this.listaNumerosAdicion.push(6);
    this.listaNumerosAdicion.push(7);
    this.listaNumerosAdicion.push(8);
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorExpedientes);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorOcurrido);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorAsignacion);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorMonitoreo);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorAdjuntos);

    if (this.utilitariosService.VerificarContieneDatos(this.menuService.ParametrosAdicionales)) {
      this.expediente = this.menuService.ParametrosAdicionales;

      this.ConsultarInformacionGeneral();
      this.ConsultarInformacionExpediente();
      this.ConsultarInformacionVistaGeneral();
    }
  }

  IniciarFormulario() {
    
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('ExpedientesComponent');
  }
  VerExpedientesAbiertos() {
    this.menuService.CambiarComponenteActivo('ExpedientesComponent', this.itemDetalleInformacionGeneral.identificacion);
  }
  VerInformacionAdicional() {
    this.mostrarCargando = true;
    let parametrosConsulta: FormGroup= this.fb.group({
      id: [0],
      idProducto: [0],
      nroDocumento: [''],
      nombres: [''],
      Aliado: [''],
      idAplicacion: [0],
      idAliado: [0],
      aliado: [''],
      listaAliadosCanales: [[]]
    });

    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
    parametrosConsulta.get('Aliado').setValue(this.autenticacionService.DescripcionAliadoSeleccionado);
    parametrosConsulta.get('idAliado').setValue(this.autenticacionService.AliadoSeleccionado);
    parametrosConsulta.get('aliado').setValue(this.autenticacionService.DescripcionAliadoSeleccionado);
    parametrosConsulta.get('nroDocumento').setValue(this.itemDetalleInformacionGeneral.identificacion);

    let listaAliadosCanales: ListaAliadosCanales[] = [];
    if (this.utilitariosService.VerificarContieneDatosLista(this.autenticacionService.UsuarioActivo.listaAliados)) {
      for (let index = 0; index < this.autenticacionService.UsuarioActivo.listaAliados.length; index++) {
        let item = this.autenticacionService.UsuarioActivo.listaAliados[index];
        if (this.utilitariosService.VerificarContieneDatosLista(item.listaCanales)) {
          for (let index2 = 0; index2 < item.listaCanales.length; index2++) {
            let itemCanal = item.listaCanales[index2];
            let itemNuevo: ListaAliadosCanales = new ListaAliadosCanales();
            itemNuevo.idAliado = item.idAliado;
            itemNuevo.idCanal = itemCanal.idCanal;
            listaAliadosCanales.push(itemNuevo);
          }
        }
      }
    }
    parametrosConsulta.get('listaAliadosCanales').setValue(listaAliadosCanales);

    this.gestionAfiliadoService.Consultar(parametrosConsulta.value)
              .subscribe((resp: GestionAfiliado[]) =>{
                this.mostrarCargando = false;
                if (this.utilitariosService.VerificarContieneDatosLista(resp)) {
                  this.menuService.CambiarComponenteActivo('GestionAfiliadosDetalleComponent', JSON.stringify(this.armarParametroEnvio(resp[0], resp)));
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  armarParametroEnvio(itemGestion: GestionAfiliado, listaConsulta: GestionAfiliado[]): GestionAfiliado_Parametro {
    let parametroAfiliado: GestionAfiliado_Parametro = new GestionAfiliado_Parametro();
    parametroAfiliado.nroDocumento = this.itemDetalleInformacionGeneral.identificacion;
    parametroAfiliado.nombres = this.itemDetalleInformacionGeneral.nombre;
    parametroAfiliado.gestionAfiliado_Seleccionado = [];
    parametroAfiliado.gestionAfiliado_Seleccionado.push(itemGestion);
    parametroAfiliado.gestionAfiliado_ListaConsulta = listaConsulta;
    parametroAfiliado.tipoRetorno = 'EXPEDIENTES';
    parametroAfiliado.parametroAdicionalTipoRetorno = this.expediente;
    return parametroAfiliado;
  }
  TituloOpcionMenu(): string {
    return `Expediente #${this.expediente}`
  }
  recargarListaExpediente() {
    this.dataSourceExpedientes = new MatTableDataSource(this.listaDetalleExpedientes);
    this.dataSourceExpedientes.paginator = this.paginatorExpedientes;
  }
  recargarListaOcurrido() {
    this.dataSourceOcurrido = new MatTableDataSource(this.listaDetalleOcurrido);
    this.dataSourceOcurrido.paginator = this.paginatorOcurrido;
  }
  recargarListaAsignacion() {
    this.dataSourceAsignacion = new MatTableDataSource(this.listaDetalleAsignado);
    this.dataSourceAsignacion.paginator = this.paginatorAsignacion;
  }
  recargarListaMonitoreo() {
    this.dataSourceMonitoreo = new MatTableDataSource(this.listaDetalleMonitoreo);
    this.dataSourceMonitoreo.paginator = this.paginatorMonitoreo;
  }
  recargarListaAdjunto() {
    this.dataSourceAdjuntos = new MatTableDataSource(this.listaDetalleAdjuntos);
    this.dataSourceAdjuntos.paginator = this.paginatorAdjuntos;
  }
  ConsultarInformacionGeneral() {
    this.mostrarCargando = true;
    let parametrosConsulta: FormGroup = this.fb.group({
      codigoExpediente: [''],
      idAplicacion: [0]
    });
    
    parametrosConsulta.get('codigoExpediente').setValue(this.expediente);
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);

    this.datosServices.ConsultarDetalle_InformacionGeneral(parametrosConsulta.value)
              .subscribe((resp: Expedientes_Detalle_InformacionGeneral_DTO[]) =>{
                this.mostrarCargando = false;
                this.listaDetalleInformacionGeneral = resp;

                if (this.utilitariosService.VerificarContieneDatosLista(this.listaDetalleInformacionGeneral)) {
                  this.itemDetalleInformacionGeneral = this.listaDetalleInformacionGeneral[0];
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarInformacionExpediente() {
    let parametrosConsulta: FormGroup = this.fb.group({
      codigoExpediente: [''],
      idAplicacion: [0]
    });
    
    parametrosConsulta.get('codigoExpediente').setValue(this.expediente);
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);

    this.datosServices.ConsultarDetalle_Expediente(parametrosConsulta.value)
              .subscribe((resp: Expedientes_Detalle_Expediente_DTO[]) =>{
                this.listaDetalleExpedientes = resp;
                this.listaDetalleOcurrido = this.listaDetalleExpedientes.filter(x => x.concepto === this.TIPODETALLE_OCURRIDO || x.concepto === this.TIPODETALLE_OBSERVACIONES);
                this.listaDetalleAsignado = this.listaDetalleExpedientes.filter(x => x.concepto === this.TIPODETALLE_ASIGNACION);
                this.listaDetalleMonitoreo = this.listaDetalleExpedientes.filter(x => x.concepto === this.TIPODETALLE_MONITOREO);
                this.listaDetalleAdjuntos = this.listaDetalleExpedientes.filter(x => x.concepto === this.TIPODETALLE_ADJUNTO);
                this.recargarListaExpediente();
                this.recargarListaOcurrido();
                this.recargarListaAsignacion();
                this.recargarListaMonitoreo();
                this.recargarListaAdjunto();

                if (this.utilitariosService.VerificarContieneDatosLista(this.listaDetalleExpedientes)) {
                  this.AbrirDetalleExpendiente(this.listaDetalleExpedientes[0]);
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarInformacionVistaGeneral() {
    let parametrosConsulta: FormGroup = this.fb.group({
      codigoExpediente: [''],
      idAplicacion: [0]
    });
    
    parametrosConsulta.get('codigoExpediente').setValue(this.expediente);
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);

    this.datosServices.ConsultarDetalle_VistaGeneral(parametrosConsulta.value)
              .subscribe((resp: Expedientes_Detalle_Expediente_DTO[]) =>{
                this.listaDetalleVistaGeneral = resp.filter(x => x.concepto !== 'Termino');
                let itemFinal = resp.filter(x => x.concepto === 'Termino');
                if (itemFinal.length > 0) {
                  this.idFinal = itemFinal[0].id;
                  this.conceptoFinal = itemFinal[0].concepto;
                  this.fechaFinal = itemFinal[0].fecha;
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  CambiarValorContenido() {
    this.mostrarContenidoPrincipal = !this.mostrarContenidoPrincipal;
  }
  CambiarValorInformacionAfiliado() {
    this.mostrarContenidoInformacionAfiliado = !this.mostrarContenidoInformacionAfiliado;
  }
  CambiarDatosAfiliado() {
    this.mostrarContenidoDatosAfiliado = !this.mostrarContenidoDatosAfiliado;
  }
  CambiarDatosContactante() {
    this.mostrarContenidoDatosContactante = !this.mostrarContenidoDatosContactante;
  }
  CambiarInformacionExpediente() {
    this.mostrarContenidoInformacionExpediente = !this.mostrarContenidoInformacionExpediente;
  }
  CambiarVistaGeneral() {
    this.mostrarContenidoVistaGeneral = !this.mostrarContenidoVistaGeneral;
  }
  CambiarContenidoDetalleExpediente() {
    this.mostrarContenidoDetalleExpediente = !this.mostrarContenidoDetalleExpediente;
  }
  ClaseEstadoEspediente(): string {
    if (this.itemDetalleInformacionGeneral.codigoEstado === this.ESTADOS_NUEVO) {
      return 'txtEstadoNuevo';
    } else if (this.itemDetalleInformacionGeneral.codigoEstado === this.ESTADOS_PROCESO) {
      return 'txtEstadoProceso';
    } else if (this.itemDetalleInformacionGeneral.codigoEstado === this.ESTADOS_SEGUIMIENTO) {
      return 'txtEstadoSeguimiento';
    } else if (this.itemDetalleInformacionGeneral.codigoEstado === this.ESTADOS_TERMINADO) {
      return 'txtEstadoTerminado';
    }
    return '';
  }
  AbrirDetalleExpendiente(itemSeleccionado: Expedientes_Detalle_Expediente_DTO) {
    this.itemDetalleExpedientes = itemSeleccionado;
  }
  DescargarAdjuntoDetalleExpendiente(itemSeleccionado: Expedientes_Detalle_Expediente_DTO) {
    if (this.utilitariosService.VerificarContieneDatosTexto(itemSeleccionado.asunto)) {
      let parametrosConsulta: FormGroup = this.fb.group({
        codigoExpediente: [''],
        nombreArchivo: [''],
        idAplicacion: [0]
      });
      
      parametrosConsulta.get('codigoExpediente').setValue(this.expediente);
      parametrosConsulta.get('nombreArchivo').setValue(itemSeleccionado.asunto);
      parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionado);
  
      this.datosServices.ConsultarDetalle_Adjunto(parametrosConsulta.value)
                .subscribe((resp: any) =>{
                  let dataType = resp.type;
                  let binaryData = [];
                  binaryData.push(resp);
                  let downloadLink = document.createElement('a');
                  downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
                  downloadLink.setAttribute('download', itemSeleccionado.asunto);
                  document.body.appendChild(downloadLink);
                  downloadLink.click();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  TextoReducidoDescripcion(descripcion: string, longitud: number): string {
    if (descripcion) {
      if (descripcion.length > longitud) {
        return `${descripcion.substring(0, longitud)}...`;
      } else {
        return descripcion;
      }
    }

    return '';
  }
  CambioTabSeleccionado(item: any) {
    this.tabSeleccionado = item.index;
    console.log('CambioTabSeleccionado', this.tabSeleccionado);

    this.itemDetalleExpedientes = new Expedientes_Detalle_Expediente_DTO();
    if (this.tabSeleccionado === 0) {
      if (this.utilitariosService.VerificarContieneDatosLista(this.listaDetalleExpedientes)) {
        this.AbrirDetalleExpendiente(this.listaDetalleExpedientes[0]);
      }
    } else if (this.tabSeleccionado === 1) {
      if (this.utilitariosService.VerificarContieneDatosLista(this.listaDetalleOcurrido)) {
        this.AbrirDetalleExpendiente(this.listaDetalleOcurrido[0]);
      }
    } else if (this.tabSeleccionado === 2) {
      if (this.utilitariosService.VerificarContieneDatosLista(this.listaDetalleAsignado)) {
        this.AbrirDetalleExpendiente(this.listaDetalleAsignado[0]);
      }
    } else if (this.tabSeleccionado === 3) {
      if (this.utilitariosService.VerificarContieneDatosLista(this.listaDetalleMonitoreo)) {
        this.AbrirDetalleExpendiente(this.listaDetalleMonitoreo[0]);
      }
    } else if (this.tabSeleccionado === 4) {
      if (this.utilitariosService.VerificarContieneDatosLista(this.listaDetalleAdjuntos)) {
        this.AbrirDetalleExpendiente(this.listaDetalleAdjuntos[0]);
      }
    }
  }
  ItemEsImpar(itemEvaluar: Expedientes_Detalle_Expediente_DTO): boolean {
    return (itemEvaluar.id % 2) !== 0;
  }
  NumeroEsImpar(idEvaluar: number): boolean {
    return (idEvaluar % 2) !== 0;
  }
  EsHTML(itemEvaluar: Expedientes_Detalle_Expediente_DTO): boolean {
    if (itemEvaluar.concepto === this.TIPODETALLE_OCURRIDO || itemEvaluar.concepto === this.TIPODETALLE_OBSERVACIONES) {
      return true;
    }
    return false;
  }
  EsOcurrido(itemEvaluar: Expedientes_Detalle_Expediente_DTO): boolean {
    if (itemEvaluar.concepto === this.TIPODETALLE_OCURRIDO) {
      return true;
    }
    return false;
  }
  EsObservaciones(itemEvaluar: Expedientes_Detalle_Expediente_DTO): boolean {
    if (itemEvaluar.concepto === this.TIPODETALLE_OBSERVACIONES) {
      return true;
    }
    return false;
  }
  AgregarClaseMargenTamanoDerecho(): boolean {
    return this.tamanoAppService.mostrarModoCelular || this.tamanoAppService.mostrarModoTablet;
  }
}
